<template>
    <div class="d-flex">
        <div class="sidebar-cart-item-left">
            <a @click="openModalMethod()" class="cursor-pointer">
                <img :srcset="`${smallPhotoJpg} 1x, ${regularPhotoJpg} 2x`" :alt="smallPhotoAlt" width="50" />
            </a>
        </div>
        <div class="sidebar-cart-item-right-without-price">
            <div class="sidebar-cart-text-price-wrapper">
                <div class="sidebar-cart-text">
                    <a
                        class="vue-anchor-title cursor-pointer"
                        :class="[anchorHoverBehavior === 'add' ? 'hover-add-underline' : 'hover-remove-underline']"
                        @click="openModalMethod()"
                    >
                        {{ anchorTitle }}</a
                    >
                    <div
                        v-if="sticker"
                        class="justify-content-center py-1 sticker-last-step d-flex"
                        style="background-color: #A6D7F5; color: #1A5FAC"
                    >
                        <span class="px-2 py-1 font-bold">{{
                            __('frontend_js.offers.1_plus_1.sticker_title')
                        }}</span>
                    </div>
                    <div class="sidebar-cart-text-subtext">
                        {{ __('frontend_js.cart.color') }}: {{ color }},
                        <span v-if="size != 'None'"> {{ __('frontend_js.cart.size') }}: {{ size }} </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        anchorTitle: {
            default: 'Empty',
            type: String,
        },
        anchorHoverBehavior: {
            default: 'add',
        },
        modalType: {
            default: 'Empty',
            type: String,
        },
        modalId: {
            default: 0,
        },
        modalCloseButton: {
            default: false,
            type: Boolean,
        },
        modalContent: {
            default: 'false',
            type: String,
        },
        anchorPicture: {
            default: false,
            type: Boolean,
        },
        smallPhotoJpg: {
            default: 'Empty',
            type: String,
        },
        regularPhotoJpg: {
            default: 'Empty',
            type: String,
        },
        smallPhotoAlt: {
            default: 'Empty',
            type: String,
        },
        user: {},
        previousModalName: {
            default: 'Empty',
            type: String,
        },
        previousModalId: {
            default: 'Empty',
            type: String,
        },
        color: {
            default: 'Empty',
            type: String,
        },
        size: {
            default: 'None',
            type: String,
        },
        sticker: {
            default: 0,
            type: Number,
        },
    },
    data() {
        return {
            openModal: false,
        };
    },
    methods: {
        openModalMethod() {
            if (this.user) {
                this.$store.commit('auth/SET_USER', this.user);
            }
            this.$store.commit('store-modals/SET_TOOGLE_MODAL', !this.openModal);
            this.$store.commit('store-modals/SET_MODAL_TYPE', this.modalType);
            this.$store.commit('store-modals/SET_MODAL_ID', this.modalId);
            this.$store.commit('store-modals/SET_MODAL_CLOSE_BUTTON', this.modalCloseButton);
            this.$store.commit('store-modals/SET_MODAL_CONTENT', this.modalContent);
            this.$store.commit('store-modals/SET_PREVIOUS_MODAL_NAME', this.previousModalName);
            if (this.previousModalId !== 'Empty') {
                this.$store.commit('store-modals/SET_PREVIOUS_MODAL_ID', this.previousModalId);
            }
        },
    },
};
</script>
<style lang="scss">
.sticker-last-step {
  /*   @media (min-width: 590px) {
        width: 36% !important;
    } */

    width: 100%;
    max-width: 110px;
}
</style>
